import { Component, Input, Output, EventEmitter, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { HhsgSharedUserApplication, HhsgSharedUserProfile } from '../../../models';
import { Constants } from '../../../utilities/constants.util';
import {
  HhsgSharedConfigService, HhsgSharedUserService, HhsgSharedApplicationsService,
} from '../../../services';
import { Subject, Subscription } from 'rxjs';
import { ScreenService } from '../../../services/screen.service';

@Component({
  selector: 'huron-header',
  templateUrl: 'header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, AfterViewInit  {
	@Output() menuToggle = new EventEmitter<boolean>();

	@Input() menuToggleEnabled = false;
	@Input() user: HhsgSharedUserProfile;
	@Input() showApplications: boolean;
	@Input() showNotifications;

	activeApplications?: Array<HhsgSharedUserApplication>;

	logoRoute: string;
	portalHome: string;
	applicationMenuCanScroll: boolean;
	applicationAbbreviation: string;

	private _unsubscribe$ = new Subject<void>();
	private _userServiceSubscription: Subscription;

	private get applicationHeader(): HTMLElement | null {
		return this.elementRef.nativeElement.querySelector('#applicationHeader .dx-toolbar-items-container');
	}

	constructor(private router: Router,
		public configService: HhsgSharedConfigService,
		protected _userService: HhsgSharedUserService,
		private _sharedApplicationService: HhsgSharedApplicationsService,
		private elementRef: ElementRef,
		private screen: ScreenService) { }

	ngAfterViewInit(): void {
		this.screen.changed.subscribe(() => this.updateHeaderScrollButtons());
		this.updateHeaderScrollButtons();
	}

	ngOnInit() {
		this.applicationAbbreviation = this.configService.appSettings.applicationAbbreviation.toLocaleLowerCase();
		this.portalHome = this.configService.appSettings.portalHome;
		this.setupUserInfo();
		this.setLogoRoute();
	}

	toggleMenu = () => {
		this.menuToggle.emit();
	}

	scrollLeft() {
		this.applicationHeader.scrollBy(-100, 0);
	}

	scrollRight() {
		this.applicationHeader.scrollBy(100, 0);
	}

	private updateHeaderScrollButtons() {
		const screenWidth = window.innerWidth;
		const applicationHeaderWidth = this.applicationHeader?.scrollWidth;
		this.applicationMenuCanScroll = applicationHeaderWidth > screenWidth;

		//console.log("HeaderScroll: header width " + applicationHeaderWidth + " screen width: " + screenWidth);
	}

	onContentReadyHeader() {
		this.updateHeaderScrollButtons();
	}

	private setupUserInfo() {
		this._userServiceSubscription = this._userService
			.getUserProfile()
			.pipe(takeUntil(this._unsubscribe$))
			.subscribe( (user: HhsgSharedUserProfile) => {
				this.user = user;
				this.createApplicationLinks();
			});
	}

	private createApplicationLinks() {
		this.activeApplications = [];
		if (this.user?.userApplications) {
			this.user.userApplications.forEach(app => {
				if (app.isActive && app.abbreviation != Constants.HuronAcceleratorsAbbreviation) {
					this.activeApplications.push(app);
				}
			});
			this.updateHeaderScrollButtons();
		}
	}

  public async openApplicationLink(application: HhsgSharedUserApplication) {
    let childApplicationUserId = this.getChildApplicationUserId(application);
    this._sharedApplicationService.openChildUrlWithApplicationSpecificToken(application.name, application.applicationId, childApplicationUserId);
  }

  private getChildApplicationUserId(app: HhsgSharedUserApplication) : number {
    let applicationModels = this.user?.userApplications?.filter(x=> x.applicationId === app.applicationId);
    return applicationModels?.length > 0 ? applicationModels[0].applicationUserId : 0;
  }

	private setLogoRoute() {
		if (this.applicationAbbreviation === Constants.HuronAcceleratorsAbbreviation.toLocaleLowerCase()) {
			this.logoRoute = '/';
		}
		else {
			this.logoRoute = this.portalHome;
		}
	}
}
